module.exports = __webpack_public_path__ + "img/2.cfd7b7e1.svg";